import { toastAtom } from '../../atoms';
import { useAtom } from '../../lib';

import './Toast.scss';
import ToastItem from './ToastItem';

const Toast = () => {
  const [toasts] = useAtom(toastAtom);

  return (
    <div className="nostra__toast">
      {toasts.map(toast => {
        return <ToastItem key={toast.id} toast={toast} />;
      })}
    </div>
  );
};
export default Toast;
